import React, {useContext, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, FreeMode, Thumbs} from "swiper";

import {Headline} from "../../components/Headline";
import {Button} from "../../components/Button";
import {Tagline} from "../../components/Tagline/Tagline";
import {SectionContainer} from "../../components/SectionContainer";
import {MediaSlideContent} from "./MediaSlideContent/MediaSlideContent";
import {useIsTablet} from "../../lib/hooks/mediaQueries";
import {generateClassString as gcs} from "../../lib/helper/generateClassString";

import * as styles from "./mediaSlider.module.less";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import GeneralPageContext from "../../templates/GeneralPageContext";
import MediaTextContext from "../MediaText/MediaTextContext";
import t from "../../lib/translate";

function MediaSlider({
                         data: {
                             anker,
                             background,
                             tagline,
                             semanticOfHeadline,
                             headline,
                             slideMedia,
                             thumbnails
                         },
                         layoutReduced
                     }) {
    const {
        layout: {showAnchorNavigation}
    } = useContext(GeneralPageContext);

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [activeElement, setActiveElement] = useState(0);
    const [description, setDescription] = useState(
        slideMedia[0]?.mediaDescription || slideMedia[0]?.media?.alt
    );

    const isTablet = useIsTablet();

    function changeSlide(swiper) {
        const {activeIndex} = swiper;
        const mediaElement = slideMedia[activeIndex];

        setActiveElement(activeIndex);

        setDescription(
            mediaElement?.mediaDescription || mediaElement?.media?.alt
        );
    }

    return (
        <MediaTextContext.Provider value={{activeElement}}>
            <SectionContainer
                sectionId={anker}
                sectionClass={styles.mediaSliderSection}
                containerClass={gcs(styles.mediaSliderContainer, [
                    showAnchorNavigation,
                    styles.anchored
                ], [
                    layoutReduced,
                    styles.layoutReduced
                ])}
                background={background}
            >
                <header>
                    <Tagline>{tagline}</Tagline>

                    <Headline semanticOfHeadline={semanticOfHeadline}>
                        {headline}
                    </Headline>
                </header>

                <div className={styles.swiperContainer}>
                    <Swiper
                        spaceBetween={1}
                        navigation={{
                            prevEl: `#buttonPrev`,
                            nextEl: `#buttonNext`
                        }}
                        thumbs={{
                            swiper: thumbsSwiper
                        }}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className={styles.mainSwiper}
                        onSlideChange={changeSlide}
                    >
                        {slideMedia?.map((mediaElement) => (
                            <SwiperSlide
                                key={mediaElement.id}
                                className={styles.mediaSlide}
                            >
                                <MediaSlideContent
                                    mediaElement={mediaElement}
                                    layoutReduced={layoutReduced}
                                />
                            </SwiperSlide>
                        ))}

                        {/* <span className={styles.mediaDescription}>{description}</span> */}

                        <Button
                            id="buttonPrev"
                            className={styles.mediaSlideBtn}
                            type="prev"
                            icon="arrowLeft"
                            aria-label={t("navigation.button.prev")}
                        />
                        <Button
                            id="buttonNext"
                            className={styles.mediaSlideBtn}
                            type="next"
                            icon="arrowRight"
                            aria-label={t("navigation.button.next")}
                        />
                    </Swiper>
                    <div className={styles.thumbSwiperBlock}>
                        <Swiper
                            onSwiper={setThumbsSwiper}
                            slidesPerView={isTablet ? "4" : "5"}
                            spaceBetween={isTablet ? 10 : 30}
                            navigation={{
                                prevEl: `#buttonPrev`,
                                nextEl: `#buttonNext`
                            }}
                            freeMode
                            watchSlidesProgress
                            modules={[FreeMode, Navigation, Thumbs]}
                            className={gcs(styles.thumbSwiper, [
                                layoutReduced,
                                styles.layoutReduced
                            ])}
                        >
                            {thumbnails?.map((mediaElement, index) => (
                                <SwiperSlide
                                    key={mediaElement.id}
                                    className={styles.thumbMediaSlide}
                                >
                                    <MediaSlideContent
                                        mediaElement={mediaElement}
                                        thumbnailsOnly={true}
                                        gridDisable={true}
                                        active={index === activeElement}
                                        activeClass={styles.active}
                                    />
                                </SwiperSlide>
                            ))}
                            <Button
                                id="buttonPrev"
                                className={styles.mediaSlideBtn}
                                type="prev"
                                icon="arrowLeft"
                                aria-label={t("navigation.button.prev")}
                            />
                            <Button
                                id="buttonNext"
                                className={styles.mediaSlideBtn}
                                type="next"
                                icon="arrowRight"
                                aria-label={t("navigation.button.next")}
                            />
                        </Swiper>
                    </div>
                </div>
            </SectionContainer>
        </MediaTextContext.Provider>
    );
}

export {MediaSlider};
